import React from "react";
import { NavLink } from "react-router-dom";
import {
  BrowserRouter,
  Switch
} from "react-router-dom";


import Layout from "./components/Layout/Layout";
import { privateRoutes, publicRoutes } from "./routes/routes";
import Authmiddleware from "./routes/AuthMiddleware";

function App() {

  return (
    <div className="App">
      <BrowserRouter>    
         <nav className="header_nav">
        <NavLink to="/player" className={({ isActive }) => `header_nav-link${isActive ? " header_nav-link--active" : ""}`}>Player Balance</NavLink>
        <NavLink to="/history" className={({ isActive }) => `header_nav-link${isActive ? " header_nav-link--active" : ""}`}>Sim History</NavLink>
        <NavLink to="/summary" className={({ isActive }) => `header_nav-link${isActive ? " header_nav-link--active" : ""}`}>Sim Summary</NavLink>
        <NavLink to="/config" className={({ isActive }) => `header_nav-link${isActive ? " header_nav-link--active" : ""}`}>Config</NavLink>
      </nav>
        <Switch>
          {publicRoutes.map((route, index) => (
            <Authmiddleware key={`pu-${index}`} path={route.path} component={route.components} exact />
          ))}

          {privateRoutes.map((route, index) => (
            <Authmiddleware key={`pr-${index}`} path={route.path} component={route.components} layout={Layout} exact />
          ))}
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default App;
